export const HANDSHAKE_INIT = "HANDSHAKE_INIT";
export const HANDSHAKE_ACK = "HANDSHAKE_ACK";
export const BATCH_MESSAGE = "BATCH_MESSAGE";
export const SCRIPT_ERROR = "SCRIPT_ERROR";

export type MessageListener = (ev: MessageEvent) => any;

export interface BufferedPort {
  postMessage: (payload: any) => void;
  internalSetPort: (port: MessagePort) => void;
  setHandshakeComplete: () => void;
}
